/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DynamicBrandingService } from '@boxx/dynamic-branding';
import { Chart, registerables } from 'chart.js';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-queries-chart-widget',
  templateUrl: './queries-chart-widget.component.html',
  styleUrls: ['./queries-chart-widget.component.scss'],
})
export class QueriesChartWidgetComponent implements OnInit {
  @ViewChild('queriesChart', { static: false }) queriesChart;

  @Input() set stats(payload: IStatsProps) {
    this.myStats = payload;

    if (payload.total) {
      this.setChartTheme();
      this.createChart([this.stats.direct, this.stats.indirect, this.stats.chain]);
    }
  }

  get stats(): IStatsProps {
    return this.myStats;
  }

  chart: Chart | any;
  chartData: any = {
    responsive: false,
    datasets: [
      {
        data: [],
        backgroundColor: [],
      },
    ],
  };

  private myStats: IStatsProps = {
    total: 0,
    direct: 0,
    indirect: 0,
    chain: 0,
  };

  constructor(dBrandingService: DynamicBrandingService) {
    Chart.register(...registerables);

    dBrandingService.themeChange$.subscribe(() => {
      if (this.chart) {
        this.setChartTheme();
        this.createChart([this.myStats.direct, this.myStats.indirect, this.myStats.chain]);
      }
    });
  }

  ngOnInit() {
    setTimeout(() => {
      try {
        this.chart = new Chart(this.queriesChart.nativeElement, {
          type: 'doughnut',
          data: this.chartData,
          options: {
            cutout: 50,
          },
        });

        // set values in order for: [client, prospect, not_specified]
        this.createChart([this.stats.direct, this.stats.indirect, this.stats.chain]);
      } catch (e) {
        console.error('-- ngOnInit chart.js error', e);
      }
    }, 800);
  }

  getPercent(num: number){
    if(num === 1){
      return this.stats.direct;//(this.stats.chain/this.stats.total*100).toFixed();
    }
    else if(num === 2){
      return this.stats.indirect;//(this.stats.indirect/this.stats.total*100).toFixed();
    }
    else if(num === 3){
      return this.stats.chain;//(this.stats.direct/this.stats.total*100).toFixed();
    }
    return null;
  }

  private setChartTheme() {
    const secondaryColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-not-specified')
      .trim();
    const tertiaryColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-prospect-color')
      .trim();
    const mediumColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--ion-color-contact-chart-client-color')
      .trim();

    this.chartData.datasets[0].backgroundColor = ['#f0c473', '#bdd86b', '#9ad3f9'];//[mediumColor, tertiaryColor, secondaryColor];
  }

  private createChart(values: Array<number>) {
    try {
      if(this.chart.data){
        this.chart.data.datasets.forEach(dataset => {
          // set values in order for: [client, prospect, not_specified]
          dataset.data = values;
        });
  
        this.chart.update();
      }
    } catch (e) {
      //console.error('-- createChart error', e);
    }
  }
}

interface IStatsProps {
  total: number;
  direct: number;
  indirect: number;
  chain: number;
}
